(function () {
  const btn = document.getElementById('nina-chatbot-btn');

  // Crear HTML del chat
  const chat = document.createElement('div');
  chat.id = 'nina-chatbot';
  chat.innerHTML = `
    <div id="nina-chatbot-header">NINA 💬</div>
    <div id="nina-chatbot-messages"></div>
    <div id="nina-chatbot-input">
      <input type="text" placeholder="Escribe tu mensaje..." />
      <button>Enviar</button>
    </div>
  `;
  document.body.appendChild(chat);

  const messages = chat.querySelector('#nina-chatbot-messages');
  const input = chat.querySelector('input');
  const sendBtn = chat.querySelector('button');

  // ======================
  // SESSION ID PERSISTENTE
  // ======================
  let sessionId = localStorage.getItem('ninaSession');
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem('ninaSession', sessionId);
  }

  // ======================
  // ABRIR / CERRAR CHAT
  // ======================
  btn.addEventListener('click', () => {
    chat.style.display = chat.style.display === 'flex' ? 'none' : 'flex';
  });

  // ======================
  // ENVIAR MENSAJE
  // ======================
  function sendMessage() {
    const text = input.value.trim();
    if (!text) return;

    renderMessage(text, 'user');
    input.value = '';

    // Typing humano
    const typingId = renderTyping();

    fetch('https://n8n.srv945691.hstgr.cloud/webhook/0abdc952-e8e2-45ae-999a-2a96e3e623ba/chat',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId,
        action: "sendMessage",
        chatInput: text
      })
    })
    .then(res => res.json())
    .then(data => {
      removeTyping(typingId);

      const res = Array.isArray(data) ? data.find(item => item.reply || item.replyMessage || item.text) || data[0] : data;

      // Delay humano pequeño
      setTimeout(() => {

        const messageText = res.reply || res.replyMessage || res.text || 'Gracias por escribirnos 😊';

        renderMessage(messageText, 'bot');

        // Mostrar productos si vienen del webhook
        if (res.products && res.products.length) {

          res.products.forEach(product => {

            const productDiv = document.createElement('div');
            productDiv.className = "nina-product";

           const img = document.createElement("img");
            img.src = product.image;
            img.alt = product.title;

            img.onerror = () => {
              img.src = "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png";
            };

            const info = document.createElement("div");
            info.innerHTML = `
              <strong>${product.title}</strong>
              <div>Cantidad: ${product.quantity}</div>
            `;

            productDiv.appendChild(img);
            productDiv.appendChild(info);

            messages.appendChild(productDiv);
            messages.scrollTop = messages.scrollHeight;

          });

        }

      }, 400 + Math.random() * 400);
    })
    .catch(() => {
      removeTyping(typingId);
      renderMessage('Ocurrió un error, intenta nuevamente.', 'bot');
    });
  }

  // ======================
  // RENDER MENSAJES
  // ======================
    function renderMessage(text, type) {
      const div = document.createElement('div');
      div.className = `nina-msg nina-${type}`;

      const p = document.createElement('div');
      div.appendChild(p);

      messages.appendChild(div);
      messages.scrollTop = messages.scrollHeight;

      if (type === 'bot') {
        // Efecto "máquina de escribir"
        let i = 0;
        const speed = 20 + Math.random() * 20; // entre 20 y 40 ms por letra
        const timer = setInterval(() => {
          p.textContent += text.charAt(i);
          messages.scrollTop = messages.scrollHeight; // seguir scroll
          i++;
          if (i >= text.length) {
            clearInterval(timer);
          }
        }, speed);
      } else {
        // Usuario: texto completo al instante
        p.textContent = text;
      }
    }

  // ======================
  // TYPING HUMANO
  // ======================
  function renderTyping() {
    const id = "typing-" + Date.now();

    const div = document.createElement('div');
    div.className = 'nina-msg nina-bot';
    div.id = id;

    const p = document.createElement('div');
    p.textContent = "Escribiendo...";

    div.appendChild(p);
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;

    return id;
  }

  function removeTyping(id) {
    const el = document.getElementById(id);
    if (el) el.remove();
  }

  // ======================
  // EVENTOS
  // ======================
  sendBtn.addEventListener('click', sendMessage);

  input.addEventListener('keypress', e => {
    if (e.key === 'Enter') sendMessage();
  });

  // ======================
  // MENSAJE INICIAL
  // ======================
  setTimeout(() => {
    renderMessage(
      'Hola 👋 Soy el asistente de NINA. Puedo ayudarte con productos, pedidos y recomendaciones de estilo.',
      'bot'
    );
  }, 600);

})();
